module.exports = __webpack_public_path__ + "42829bd3e9f964c8a4287d083320c45c.jpg";